import container from '../container/container';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

type AnimatedElement = {
	selector: string;
	sectionName: string;
	options: {
		animCls?: string
		dontClearDelay?: boolean
		once?: boolean
	}
}

const scroll = (function () {

	let privateVars: {
		name: string;
		animatedElements: Map<string, AnimatedElement>;
		animatedElementsRegistered: Map<string, boolean>;
		animatedElementsCleaned: Map<string, boolean>;
		animatedElementsOnceFired: Map<string, boolean>;
	} = {
		name: 'scroll',
		animatedElements: new Map(),
		animatedElementsRegistered: new Map(),
		animatedElementsCleaned: new Map(),
		animatedElementsOnceFired: new Map()
	};

	const privateMethods = {
		prepareObj: function () {
			privateMethods.startup();
			privateMethods.bind();
		},
		startup: function () {
			gsap.registerPlugin(ScrollTrigger);
		},
		bind: function () {
			container.msg(privateVars.name, 'module started');

			if (window.matchMedia('(hover: hover) and (pointer: fine)')) {
				window.addEventListener('scroll', () => {

					let ticking = false;

					if (!ticking) {
						window.requestAnimationFrame(function () {
							try {
								privateMethods.handleCurrentScrollPosition();
							} catch (e) {
								container.msg(privateVars.name, ' scroll element error');
							}
							ticking = false;
						});
					}
					ticking = true;

				});

				window.addEventListener('resize', function () {
					privateMethods.handleCurrentScrollPosition();
				});

				window.addEventListener('orientationchange', function () {
					privateMethods.handleCurrentScrollPosition();
				});
			}
		},

		handleCurrentScrollPosition: () => {
			privateVars.animatedElements.forEach((value, key) => {
				if (!privateVars.animatedElementsRegistered?.get(key)) {
					// console.log(`element ${key} not registered`);

					privateVars.animatedElementsRegistered.set(key, true);

					let once = false;

					if(value.options.once) {
						once = true;
					}

					gsap.from(value.selector, {
						// scaleX: 0.3, scaleY: 0.3, scaleZ: 0.3,
						// opacity: 0,
						scrollTrigger: {
							trigger: value.selector,
							once: once,
							toggleActions: 'restart none restart none',
							onToggle: ({ isActive }: { isActive: boolean }) => {
								if(!value.options.animCls) {
									return;
								}

								if(privateVars.animatedElementsOnceFired.get(value.selector)) {
									return;
								}

								if (isActive) {
									document.querySelector(value.selector)?.classList
										.add('animate__animated', value.options.animCls);

									privateVars.animatedElementsOnceFired.set(value.selector, true);
								} else {
									document.querySelector(value.selector)?.classList
										.remove('animate__animated', value.options.animCls);
								}
							},
						},
						duration: 0.6
					});

					if(!ScrollTrigger.isInViewport(value.selector) && value.options.animCls) {
						document.querySelector(value.selector)?.classList
							.remove('animate__animated', value.options.animCls, 'animate__delay-01s',
								'animate__delay-02s', 'animate__delay-03s', 'animate__delay-04s',
								'animate__delay-05s', 'animate__delay-06s', 'animate__delay-07s',
								'animate__delay-08s', 'animate__delay-09s', 'animate__delay-1s');
					}
				}

				if (!privateVars.animatedElementsCleaned?.get(key)) {
					if(!ScrollTrigger.isInViewport(value.selector) && value.options.animCls) {
						document.querySelector(value.selector)?.classList
							.remove('animate__delay-01s',
								'animate__delay-02s', 'animate__delay-03s', 'animate__delay-04s',
								'animate__delay-05s', 'animate__delay-06s', 'animate__delay-07s',
								'animate__delay-08s', 'animate__delay-09s', 'animate__delay-1s',
								'animate__delay-1-1s', 'animate__delay-1-2s');

						privateVars.animatedElementsCleaned.set(key, true);
					}
				}
			});
		},

		registerAnimatedElement: (selector: AnimatedElement['selector'], sectionName: AnimatedElement['sectionName'],
		                          options: AnimatedElement['options']) => {
			privateVars.animatedElements.set(selector, {
				selector, sectionName, options
			});
			privateVars.animatedElementsRegistered.set(selector, false);
			privateVars.animatedElementsOnceFired.set(selector, false);

			if(options.dontClearDelay) {
				privateVars.animatedElementsCleaned.set(selector, true);
			} else {
				privateVars.animatedElementsCleaned.set(selector, false);
			}
		},

		unregisterAnimatedElement: function (selector: string) {
			privateVars.animatedElements.delete(selector);
			privateVars.animatedElementsRegistered.delete(selector);
			privateVars.animatedElementsCleaned.delete(selector);
			privateVars.animatedElementsOnceFired.delete(selector);
		},
	};


	return {
		init: function () {
			privateMethods.prepareObj();
		},
		registerAnimatedElement: privateMethods.registerAnimatedElement,
		unregisterAnimatedElement: privateMethods.unregisterAnimatedElement
	};

})();

export default scroll;